import { useMemo } from 'react';
import { Container } from 'reactstrap';

import {
  StudyPlansListLoaderConsumer,
  StudyPlansListLoaderProvider,
} from '../../hooks/StudyPlansListLoader';
import { StudyPlansList } from './StudyPlansList';

const ITEMS_PER_PAGE = 10;

interface StudyPlansListContainerProps {
  filters?: {
    name?: string;
    code?: string;
    schoolId?: number;
    modalityId?: number;
    campusId?: number;
  };
}

export function StudyPlansListContainer({
  filters,
}: StudyPlansListContainerProps) {
  const filterKey = useMemo(() => JSON.stringify(filters ?? {}), [filters]);

  return (
    <StudyPlansListLoaderProvider
      key={filterKey}
      fetchImmediately
      defaultQuery={{
        items_per_page: ITEMS_PER_PAGE,
        page: 0,
        ...filters,
      }}
    >
      <div className="w-100 mt-2 d-flex flex-wrap justify-content-center">
        <StudyPlansListLoaderConsumer>
          <Container fluid className="px-0">
            <StudyPlansList />
          </Container>
        </StudyPlansListLoaderConsumer>
      </div>
    </StudyPlansListLoaderProvider>
  );
}
